import { TimeOfDay, WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { commonTranslationKeys, TranslateFunction } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type DayOfWeek = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
const ORDERED_DAYS_OF_WEEK: DayOfWeek[] = [
   'MONDAY',
   'TUESDAY',
   'WEDNESDAY',
   'THURSDAY',
   'FRIDAY',
   'SATURDAY',
   'SUNDAY',
];

const ORDERED_TIMES_OF_DAY: TimeOfDay[] = ['MORNING', 'AFTERNOON', 'EVENING'];

export const mapPatientAvailabilityToNote = (
   patientAvailability: WaitlistEntry['patientAvailability'],
   translate: TranslateFunction
): string => {
   return ORDERED_DAYS_OF_WEEK.reduce((acc, dayOfWeek) => {
      const dayPreference = patientAvailability[dayOfWeek];

      if (!dayPreference) {
         return acc;
      }

      const timePreferencesDescription =
         dayPreference.length === ORDERED_TIMES_OF_DAY.length
            ? translate(translationKeys.withoutRestrictions)
            : ORDERED_TIMES_OF_DAY.reduce((timesOfDayAcc, timeOfDay) => {
                 if (!dayPreference.includes(timeOfDay)) {
                    return timesOfDayAcc;
                 }
                 const timeOfDayDescription = translate(translationKeys.timeOfDayMap[timeOfDay]);
                 return timesOfDayAcc ? `${timesOfDayAcc}, ${timeOfDayDescription}` : timeOfDayDescription;
              }, '');

      return `${acc}${translate(
         commonTranslationKeys.dayOfWeekAbbreviationMap[dayOfWeek]
      )} ${timePreferencesDescription}, `;
   }, '');
};
